module.exports = __webpack_public_path__ + "static/7-aa5678c169ab1faee7284e7f59895b8f.jpeg";